export default __webpack_public_path__ + "static/media/curved10.fea9af7a.jpg";